import { IAppError } from "../interfaces/IAppError";

enum ErrorNames {
    ClientError = "ClientError",
    ServerError = "ServerError",
    RequestError = "RequestError",
}

enum AppErrorNames {
    BAD_REQUEST = "BAD_REQUEST",
    MATCHING_RECORD_EXISTS = "MATCHING_RECORD_EXISTS",
    LIMIT_EXCEEDED = "LIMIT_EXCEEDED",
    UNAUTHORIZED = "UNAUTHORIZED",
    CODE_INVALID = "CODE_INVALID",
    FORBIDDEN = "FORBIDDEN",
    NOT_FOUND = "NOT_FOUND",
    ACTIVE_SESSION_CONFLICT = "ACTIVE_SESSION_CONFLICT",
    CODE_EXPIRED = "CODE_EXPIRED",
    CODE_USED = "CODE_USED",
    TOKEN_EXPIRED = "TOKEN_EXPIRED",
    TOKEN_USED = "TOKEN_USED",
    TOKEN_REVOKED = "TOKEN_REVOKED",
    UNEXPECTED_CLIENT_ERROR = "UNEXPECTED_CLIENT_ERROR",
    INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR"
}

export const AppErrors: Record<AppErrorNames, IAppError> = {
    // 400 statuses
    [AppErrorNames.BAD_REQUEST]: {
        statusCode: 400,
        code: AppErrorNames.BAD_REQUEST,
        isUserFacing: true,
        name: ErrorNames.RequestError,
        message: "Malformed request"
    },
    [AppErrorNames.MATCHING_RECORD_EXISTS]: {
        statusCode: 400,
        code: AppErrorNames.MATCHING_RECORD_EXISTS,
        isUserFacing: true,
        name: ErrorNames.RequestError,
        message: "A matching record already exists"
    },
    [AppErrorNames.LIMIT_EXCEEDED]: {
        statusCode: 400,
        code: AppErrorNames.LIMIT_EXCEEDED,
        isUserFacing: true,
        name: ErrorNames.RequestError,
        message: "The request exceeds one or more limits"
    },
    [AppErrorNames.CODE_INVALID]: {
        statusCode: 400,
        code: AppErrorNames.CODE_INVALID,
        isUserFacing: true,
        name: ErrorNames.RequestError,
        message: "Invalid code"
    },
    [AppErrorNames.UNAUTHORIZED]: {
        statusCode: 401,
        code: AppErrorNames.UNAUTHORIZED,
        isUserFacing: true,
        name: ErrorNames.RequestError,
        message: "Unauthenticated request"
    },
    [AppErrorNames.FORBIDDEN]: {
        statusCode: 403,
        code: AppErrorNames.FORBIDDEN,
        isUserFacing: true,
        name: ErrorNames.RequestError,
        message: "Unauthorized request"
    },
    [AppErrorNames.NOT_FOUND]: {
        statusCode: 404,
        code: AppErrorNames.NOT_FOUND,
        isUserFacing: true,
        name: ErrorNames.RequestError,
        message: "The requested resource could not be found"
    },
    [AppErrorNames.ACTIVE_SESSION_CONFLICT]: {
        statusCode: 409,
        code: AppErrorNames.ACTIVE_SESSION_CONFLICT,
        isUserFacing: true,
        name: ErrorNames.RequestError,
        message: "You are already logged in"
    },
    [AppErrorNames.CODE_EXPIRED]: {
        statusCode: 410,
        code: AppErrorNames.CODE_EXPIRED,
        isUserFacing: true,
        name: ErrorNames.RequestError,
        message: "The code has expired"
    },
    [AppErrorNames.CODE_USED]: {
        statusCode: 410,
        code: AppErrorNames.CODE_USED,
        isUserFacing: true,
        name: ErrorNames.RequestError,
        message: "The code has already been used"
    },
    [AppErrorNames.TOKEN_EXPIRED]: {
        statusCode: 410,
        code: AppErrorNames.TOKEN_EXPIRED,
        isUserFacing: true,
        name: ErrorNames.RequestError,
        message: "The token has expired"
    },
    [AppErrorNames.TOKEN_USED]: {
        statusCode: 410,
        code: AppErrorNames.TOKEN_USED,
        isUserFacing: true,
        name: ErrorNames.RequestError,
        message: "The token has already been used"
    },
    [AppErrorNames.TOKEN_REVOKED]: {
        statusCode: 410,
        code: AppErrorNames.TOKEN_REVOKED,
        isUserFacing: true,
        name: ErrorNames.RequestError,
        message: "The token has been revoked"
    },
    // 500 statuses
    [AppErrorNames.UNEXPECTED_CLIENT_ERROR]: {
        // statusCode: 500, // No http status because the error occurred on the client side
        code: AppErrorNames.UNEXPECTED_CLIENT_ERROR,
        isUserFacing: true,
        name: ErrorNames.ClientError,
        message: "An unexpected error occurred"
    },
    [AppErrorNames.INTERNAL_SERVER_ERROR]: {
        statusCode: 500,
        code: AppErrorNames.INTERNAL_SERVER_ERROR,
        isUserFacing: false,
        name: ErrorNames.ServerError,
        message: "An unexpected server error occurred"
    }
}